// /*
//  *  Project: jQuery Panel Scroller
//  *  Author: Daniel Darvile
//  *  License: MIT
//  */
// ;(function ($, window, document, undefined) {
//
//     var pluginName = "panelScroller",
//         dataKey = "plugin_" + pluginName;
//
//     var Plugin = function (element, options) {
//
//         this.element = element;
//
//         this.options = {
//             background: '#000',
//             color: '#999',
//             orientation: '',
//             callback: function(){}
//         };
//
//         this.init(options);
//     };
//
//     Plugin.prototype = {
//         init: function (options) {
//             $.extend(this.options, options);
//
//             if(this.element.find('.pn-scroll-wrapper').length > 0) {
//                 this.movePanel();
//
//             } else {
//                 this.buildPanel();
//             }
//
//             this.wrapper = this.element.find('.pn-scroll-wrapper');
//             this.panel   = this.element.find('.pn-scroll');
//
//         },
//
//         buildPanel: function() {
//             this.element.append('<div class="pn-scroll-wrapper"><div class="pn-scroll"></div></div>');
//
//             this.element.find('.pn-scroll-wrapper').css({
//                 'left': this.element.offset().left,
//                 'top': this.element.offset().top,
//                 'height': this.element.outerHeight(),
//                 'width': this.element.outerWidth()
//             });
//
//             this.movePanel();
//         },
//
//         movePanel: function () {
//             var pos = this.options.orientation === 'rtl' ? 0 : '100%',
//                 that = this;
//
//             this.element.find('.pn-scroll').css('left', this.options.orientation === 'rtl' ? '100%' : 0);
//
//             this.element.find('.pn-scroll').stop('true', 'true').animate({
//                 left: pos
//             }, 500, function() {
//                 // Animation complete.
//                 that.options.callback.call(that);
//             });
//         },
//
//         destroy: function() {
//             console.log('destroying');
//             this.wrapper.remove();
//         },
//
//         color: function (color) {
//             this.options.color = color;
//             this.element.css('color', color);
//         },
//
//         background: function (color) {
//             this.options.background = color;
//             this.element.css('background-color', color);
//         }
//     };
//
//     /*
//      * Plugin wrapper, preventing against multiple instantiations and
//      * return plugin instance.
//      */
//     $.fn[pluginName] = function (options) {
//
//         var plugin = this.data(dataKey);
//
//         // has plugin instantiated ?
//         if (plugin instanceof Plugin) {
//             // if have options arguments, call plugin.init() again
//             if (typeof options !== 'undefined') {
//                 plugin.init(options);
//             }
//         } else {
//             plugin = new Plugin(this, options);
//             this.data(dataKey, plugin);
//         }
//
//         return plugin;
//     };
//
// }(jQuery, window, document));